export default __webpack_public_path__ + "static/b3268637-7b92-4f81-9d7f-1ee8e8a5d517-ad15061e029eb34230bf2c55b3481662.ttf";